import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserLevel } from '@app/core/models/user-level';
import { MenuService } from '@app/menu/services/menu.service';

@Directive({
  selector: '[portalMenuLevelIsEnterprise]',
  standalone: false,
})
export class MenuLevelIsEnterpriseDirective implements OnInit {
  constructor(
    private menuService: MenuService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  public ngOnInit() {
    this.viewContainer.clear();

    if (this.menuService.isActive(UserLevel.EnterpriseAdmin, true)) {
      this.viewContainer.createEmbeddedView(this.template);
    }
  }
}
